import { format } from 'date-fns';
import { uk } from 'date-fns/locale';
import i18next from 'i18next';
import { CalendarIcon } from 'lucide-react';
import React, { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

import { FormControl } from './form';

interface DatePickerProps {
  value: string;
  onChange: (value: string) => void;
  form?: boolean;
}

function DatePicker({ value, onChange, form }: DatePickerProps) {
  const [calendarOpen, setCalendarOpen] = useState(false);

  const ButtonWrapper = form ? FormControl : React.Fragment;

  return (
    <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
      <PopoverTrigger asChild>
        <ButtonWrapper>
          <Button
            variant="outline"
            size="lg"
            className={cn('pl-3 text-left font-normal', !value && 'text-muted-foreground')}
          >
            {!!value ? value : <span>{i18next.t('placeholders.date')}</span>}
            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
          </Button>
        </ButtonWrapper>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={new Date(value)}
          onSelect={date => {
            if (date) {
              onChange(format(date, 'dd.MM.yyyy'));
            }
            setCalendarOpen(false);
          }}
          locale={uk}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export { DatePicker };
